import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "truncated-text-toggle",
	templateUrl: "./index.component.html",
	styleUrls: ["./index.component.scss"],
})
export class TruncatedTextToggleComponent implements OnInit {
	@Input() data: string;
	@Input() maximum: number;
	showData: string = "";
	showExpandMoreBtn: boolean = false;
	showCollapseBtn: boolean = false;

	constructor() {}

	ngOnInit() {
		if (this.data.length > this.maximum) {
			this.showExpandMoreBtn = true;
			this.showData = this.data.substring(0, this.maximum) + "...";
		} else {
			this.showData = this.data;
		}
	}

	showAll() {
		this.showExpandMoreBtn = false;
		this.showCollapseBtn = true;
		this.showData = this.data;
	}

	collapse() {
		this.showExpandMoreBtn = true;
		this.showCollapseBtn = false;
		this.showData = this.data.substring(0, this.maximum) + "...";
	}
}
